// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"21040eff","144":"dceb353f","278":"821bb483","322":"6ef71014","445":"004f6f1d","600":"fc5d2752","679":"edf2ad42","841":"f477a2d0","871":"dccf9453","979":"d5250b0c"}[chunkId] + ".chunk.js";
};